const INDEX_ITEMS = [
  { title: '大陆剧全集', desc: '热播国产大剧一网打尽', icon: 'ri-tv-line', count: '800+部', color: 'primary' },
  { title: '最新韩剧', desc: '高分韩剧同步更新', icon: 'ri-heart-pulse-line', count: '300+部', color: 'accent' },
  { title: '经典港剧', desc: 'TVB经典重温专区', icon: 'ri-building-2-line', count: '200+部', color: 'secondary' },
  { title: '古装仙侠', desc: '唯美古风视觉盛宴', icon: 'ri-magic-line', count: '150+部', color: 'primary' },
  { title: '悬疑探案', desc: '烧脑推理高分之作', icon: 'ri-search-eye-line', count: '120+部', color: 'accent' },
  { title: '都市情感', desc: '现实题材引发共鸣', icon: 'ri-user-heart-line', count: '180+部', color: 'secondary' },
  { title: '高分台剧', desc: '口碑台剧深度推荐', icon: 'ri-star-smile-line', count: '80+部', color: 'primary' },
  { title: '经典日剧', desc: '日剧佳作收藏馆', icon: 'ri-sun-line', count: '100+部', color: 'accent' },
  { title: '美剧精选', desc: '高分美剧全集放送', icon: 'ri-global-line', count: '90+部', color: 'secondary' },
];

const colorMap: Record<string, { bg: string; text: string; border: string; hover: string }> = {
  primary: { bg: 'bg-primary-500/10', text: 'text-primary-400', border: 'hover:border-primary-500/20', hover: 'group-hover:bg-primary-500/5' },
  accent: { bg: 'bg-accent-500/10', text: 'text-accent-500', border: 'hover:border-accent-500/20', hover: 'group-hover:bg-accent-500/5' },
  secondary: { bg: 'bg-secondary-500/10', text: 'text-secondary-400', border: 'hover:border-secondary-500/20', hover: 'group-hover:bg-secondary-500/5' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100/60 text-accent-700 text-xs font-medium mb-4">
              分类浏览
            </span>
            <h2 className="text-2xl md:text-4xl font-bold text-foreground-950 font-heading">
              剧集分类索引
            </h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-lg mx-auto">
              按类型快速找到你想看的剧集，每种类型都有专属精选推荐
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {INDEX_ITEMS.map((item, i) => {
              const c = colorMap[item.color];
              return (
                <div
                  key={i}
                  className={`group flex items-center gap-4 p-4 md:p-5 bg-background-50 rounded-xl border border-background-200/40 ${c.border} ${c.hover} transition-all duration-200 cursor-pointer`}
                >
                  <div className={`w-11 h-11 md:w-12 md:h-12 flex-shrink-0 flex items-center justify-center rounded-xl ${c.bg} ${c.text} group-hover:scale-110 transition-transform duration-200`}>
                    <i className={`${item.icon} text-xl`}></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <h3 className="text-sm md:text-base font-semibold text-foreground-950 whitespace-nowrap">{item.title}</h3>
                    </div>
                    <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
                  </div>
                  <span className="flex-shrink-0 text-xs font-medium text-foreground-400">{item.count}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}